module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"","copy":"","submit":"","submitButtonLoading":""},"es-MX":{"title":"RSVP","copy":"Por favor confirme su asistencia a la boda de {bride} y {groom} en Guadalajara, Jalisco.","submit":"Enviar","submitButtonLoading":"Enviando"}}')
  delete Component.options._Ctor
}
